export default __webpack_public_path__ + "static/media/Q2_0.3d1ff4f5.png";